export default __webpack_public_path__ + "static/media/osquery.5f6fbb96.svg";